import { MARQUEE_ITEMS } from "@/data/site";

function Row({ className }) {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className={`flex whitespace-nowrap ${className}`}>
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-4xl md:text-6xl text-stroke-muted px-6">
            {t}
          </span>
          <span className="text-primary text-3xl md:text-5xl">✦</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-white/10 bg-[#0B132B] py-8 overflow-hidden"
    >
      <Row className="animate-marquee" />
    </section>
  );
}
